const Colors = {
  primary: "#EC5F41",
  gradientRed: "#D43D5D",
  gradientYellow: "#DE8A33",
};

export default Colors;
